// Role
export const apiGetByRoleId = `Role/GetByRoleId`
export const apiCreateOrUpdateRole = `Role/CreateOrUpdateRole`
export const apiGetListRole = `Role/GetList`
export const apiGetAllForCombobox = `Role/GetAllForCombobox`
export const apiDeleteRole = `Role/DeleteRole`
export const apiGetListTab = `Role/GetListTab`
export const apiGetListTask = `Role/GetListTask`